import {  Marker } from "@react-google-maps/api";
import { Location } from "./Map";

export const Markers = ({ markers }: { markers: Location[] }) => {
  {
    return (
      <>
        {markers.map((m) => {


          return (
            <div key={m.lat}>
              <Marker position={m} />
              {/* <InfoWindow
                position={m}
                options={{ pixelOffset: new google.maps.Size(0, -30) }}
              >
                <div>
                  <h2>Marker Info</h2>
                  <p>ID: {m.lat}</p>
                  <p>Latitude: {m.lat}</p>
                  <p>Longitude: {m.lng}</p>
                </div>
              </InfoWindow> */}
            </div>
          );
        })}
      </>
    );
  }
};
